export enum AutocompleteInfinite {
  PageSize = 50,
  StaleTime = 60 * 1000,
}
